import { map, includes } from "lodash/fp";

import {
  MESSAGING_BOT_PROVIDERS_BY_ID,
  EMAIL_PROVIDERS,
} from "@app/common/constants/providers";
import type { IntegrationScope } from "@app/common/types";
import { getAppUrl } from "@app/utils/utils";

import { withQueryParamsUrl } from "./queryParamUtils";

const EMAIL_PROVIDER_IDS = map("id", EMAIL_PROVIDERS);
export const isEmailProvider = (provider?: string) =>
  provider && includes(provider, EMAIL_PROVIDER_IDS);

export const getIntegrationConnectUrl = ({
  action,
  returnParams,
  returnRoute,
  route,
  scope,
}: {
  action: string;
  returnParams?: Parameters<typeof withQueryParamsUrl>[2];
  returnRoute: string;
  route: string;
  scope?: IntegrationScope;
}) =>
  getAppUrl(
    withQueryParamsUrl(route, {
      return_url: getAppUrl(
        withQueryParamsUrl(returnRoute, { action, success: true }, returnParams)
      ),
      error_url: getAppUrl(
        withQueryParamsUrl(
          returnRoute,
          { action, success: false },
          returnParams
        )
      ),
      scope,
    })
  );

export const getSlackConnectUrl = (opts: {
  returnRoute: string;
  scope: IntegrationScope;
}) =>
  getIntegrationConnectUrl({
    action: MESSAGING_BOT_PROVIDERS_BY_ID.slack_bot.connectAction,
    route: MESSAGING_BOT_PROVIDERS_BY_ID.slack_bot.connectUrl,
    ...opts,
  });
